// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button, Input } from "../../../revvComponents";

import withRbac from "../../../app/withRbac";

// Internal Imports
import { PERMISSIONS } from "../../../constants";

export default function PricelistBar(props) {
  const { filterTxt, onFilterChange, togglePopUp } = props;

  const AddPBItemBtn = withRbac(() => (
    <Button
      className="pricelist-additem"
      type="button"
      onClick={() => togglePopUp("showPricebookWizard", true)}
      data-test="pricelist-add-product-btn">
      Add product to Price Book
    </Button>
  ));

  const AddColumnBtn = withRbac(() => (
    <Tooltip placement="top" overlay="Add New Column to this Price Book">
      <Button
        className="btn-default pricelist-addcolumn"
        type="six"
        onClick={() => togglePopUp("addGridColumnPopUp", true)}
        data-test="pricelist-add-column-btn">
        <i>
          <FontAwesomeIcon icon={["far", "table"]} />
        </i>
        Add Column
      </Button>
    </Tooltip>
  ));

  const ManageColumnsBtn = withRbac(() => (
    <Tooltip
      placement="top"
      overlay="Manage visibility of the columns based on roles">
      <Button
        className="btn-default pricelist-settings"
        type="six"
        onClick={() => togglePopUp("manageColumnPopUp", true)}
        data-test="pricelist-manage-columns-btn">
        <i>
          <FontAwesomeIcon icon={["far", "eye"]} />
        </i>
        Hide/view columns
      </Button>
    </Tooltip>
  ));

  return (
    <div className="pricelistbar-wrapper">
      <div className="pricelistbar-actions">
        <div className="pricelistbar-search">
          <i className="pricelistbar-searchicon">
            <FontAwesomeIcon icon={["far", "search"]} />
          </i>
          <Input
            className="pricelistbar-input"
            placeholder="Search products"
            value={filterTxt}
            onChange={onFilterChange}
            data-test="pricelist-search-input"
          />
        </div>
        <AddColumnBtn
          permission={PERMISSIONS.SETTINGS.MANAGE_COMPANY_SETTINGS}
        />
        <ManageColumnsBtn
          permission={PERMISSIONS.SETTINGS.MANAGE_COMPANY_SETTINGS}
        />
      </div>
      <AddPBItemBtn permission={PERMISSIONS.PRICEBOOKS.UPDATE_PRICEBOOKS} />
    </div>
  );
}

PricelistBar.propTypes = {
  // Actions
  togglePopUp: PropTypes.func.isRequired,
};
